<script src="https://cdn.plaid.com/link/v2/stable/link-initialize.js"></script>
<script>
import { mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      linkHandler: {},
    };
  },
  methods: {
    ...mapActions(["createLinkToken", "saveBankAccount"]),
    ...mapMutations(["pushToast"]),
    //Open Plaid Link Modal
    openLink() {
      this.linkHandler.open();
    },
  },
  async created() {
    //Create a link token; state action passes teamId to api; Plaid requires some unique identifier
    let linkToken = await this.createLinkToken();
    //Configure plaid link with token, environment, and custom behavior onSuccess, onExit, onLoad (not used)
    let linkHandler = await Plaid.create({
      token: linkToken.data.result.link_token,
      env: process.env.VUE_APP_PLAID_ENV,
      onSuccess: async (public_token, metadata) => {
        //Send the public token to backend to exchange for access_token, to be exchanged for a bank account token and saved to customer
        let response = await this.saveBankAccount({
          public_token: public_token,
          metadata: metadata,
        });
        if (response.ok) {
          this.$emit("savedBA");
        }
      },
      onExit: (err, metadata) => {
        if (err != null) {
          this.pushToast({
            title: "Error",
            message: err.display_message,
            variant: "danger",
          });
        }
      },
    });
    //Set the data attribute linkHandler to the object we just configured so we can call it in the page
    this.linkHandler = linkHandler;
  },
};
</script>

<template>
  <b-button variant="light" @click="openLink">
    Connect a Bank Account with
    <img class="icon" src="@/assets/Plaid_(company)-Logo.wine.png" />
  </b-button>
</template>

<style scoped>
.icon {
  height: 60px;
  width: 90px;
}
</style>
